import * as React from 'react'
import * as css from './HeroHexPattern.module.css'
import hexLight from 'assets/hex-light.svg'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'
import LazyVideo from 'components/common/LazyVideo'
import clsx from 'clsx'

const HeroHexPattern = ({ title, _rawDescription, link, video }) => (
  <section className="relative grid md:grid-cols-2 gap-y-16 items-ctnr py-8 padding-x mb-8 <md:overflow-hidden">
    <div className={`${css.txt} richtext`}>
      <h2 className="h0">{title}</h2>
      <SanityBlock body={_rawDescription} />
      <CTALink {...link} />
    </div>

    <figure className={clsx(video && css.video, 'grid place-content-center h-full padding-x')}>
      <img
        className={css.img}
        src={hexLight}
        alt=""
        width={767} height={402}
        loading="lazy" draggable="false"
      />

      {video && <LazyVideo {...video} />}
    </figure>
  </section>
)

export default HeroHexPattern
